<template>
	<div :class="marginX">
	   <b-alert show dismissible variant="danger"
	   		@dismissed="dismiss">
			<strong>Something went wrong! </strong><br/>{{message}}
			<div v-if="display">
				<ul v-for="(exception, index) in data"
					:key="index">
					<li>{{exception[0]}}</li>
				</ul>
			</div>
		</b-alert>
	</div> 
</template>

<script>
	export default {
		props: {
			message: {
				type: String,
				default: ''
			},
			data: {
				default: {}
			},
			marginX: {
				type: String,
				default: 'mx-2'
			}
		},
		data() {
			return {
				display: false
			}
		},
		methods: {
			dismiss() {
				this.$store.commit('CLEAR_EXCEPTIONS');
			}
		},
		components: {
		},
		created() {
			if (Object.keys(this.data).length < 5) {
				this.display = true;
			} else {
				this.display = false;
			}
		},
		
	}    
</script>
